import { ConfirmDialog } from '~/components/ConfirmDialog/ConfirmDialog';
import { ContextMenu } from '~/components/ContextMenu/ContextMenu';
import { useAuthentication } from '~/hooks/useAuthentication';
import { useDeleteLicenseMutation } from '../../mutations';
import { insertOnCondition } from '~/utils/array';
import { Table } from '~/components/Table/Table';
import { Link } from '~/components/Link/Link';
import { useDialog } from '~/hooks/useDialog';
import { toast } from 'react-toastify';
import { License } from '~/apis/ssf';

interface Props {
  isLoading: boolean;
  licenses: License[];
}

function Row({ license }: { license: License }) {
  const { can } = useAuthentication();

  const mutation = useDeleteLicenseMutation();
  const dialog = useDialog();

  async function handleDelete() {
    await toast.promise(mutation.mutateAsync(license.id), {
      pending: 'Tar bort licens...',
      success: 'Licensen har tagits bort',
    });
  }

  return (
    <Table.Row>
      <Table.Col>
        <Link to={`/clubs/${license.club?.id}`}>{license.club?.name}</Link>
      </Table.Col>
      <Table.Col>{license.start_date}</Table.Col>
      <Table.Col>{license.end_date}</Table.Col>
      <Table.Col align="right">
        <Table.Context
          items={[
            ...insertOnCondition(
              <ContextMenu.Item label="Redigera" key="edit" to={`${license.id}/edit`} />,
              can('edit-lifter-license')
            ),
            ...insertOnCondition(
              <ContextMenu.Item label="Ta bort" key="delete" onClick={dialog.open} danger />,
              can('delete-lifter-license')
            ),
          ]}
        />
      </Table.Col>
      <ConfirmDialog {...dialog} isLoading={mutation.isPending} onConfirm={handleDelete} />
    </Table.Row>
  );
}

export function LicensesListTable({ licenses, isLoading }: Props) {
  return (
    <Table bg="even">
      <Table.Head>
        <Table.Row>
          <Table.Col as="th">Förening</Table.Col>
          <Table.Col as="th">Start</Table.Col>
          <Table.Col as="th">Slut</Table.Col>
          <Table.Col as="th" />
        </Table.Row>
      </Table.Head>
      <Table.Body>
        {isLoading ? (
          <Table.Loading cols={3} />
        ) : licenses.length > 0 ? (
          licenses.map(license => <Row license={license} key={license.id} />)
        ) : (
          <Table.Empty colSpan={4} text="Denna lyftaren har för tillfället inga licenser" />
        )}
      </Table.Body>
    </Table>
  );
}
